import { createFileRoute, notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { renderServerComponent } from "@tanstack/react-start/rsc";
import { DPA_PUBLISHED, TITLE } from "shared/SharedConstants";
import { metadataHead } from "src/lib/Metadata";
import { withHydrationMarker } from "src/lib/ServerContent";
import { renderCachedServerComponent } from "src/server/FlightCache";

// While DPA_PUBLISHED is false the inline-constants transform folds these branches, so neither the
// addendum body nor its metadata reaches the build output; /dpa answers 404. Once published it is a
// server component, like the Terms (src/routes/_policies/terms.tsx).
const getDpaContent = createServerFn({ method: "GET" }).handler(async () => {
  if (!DPA_PUBLISHED) throw notFound();
  const { default: DataProcessingAddendum } = await import(
    "src/components/policies/DataProcessingAddendum/DataProcessingAddendum"
  );
  return renderCachedServerComponent("policy:dpa", () =>
    renderServerComponent(withHydrationMarker(<DataProcessingAddendum />)),
  );
});

export const Route = createFileRoute("/_policies/dpa")({
  beforeLoad: () => {
    if (!DPA_PUBLISHED) throw notFound();
  },
  loader: () => getDpaContent(),
  staleTime: Number.POSITIVE_INFINITY,
  head: () =>
    DPA_PUBLISHED
      ? metadataHead({
          title: "Data Processing Addendum",
          description: `The terms under which ${TITLE} processes personal data in Customer Content on its customers' behalf (UK GDPR and EU GDPR Article 28).`,
          alternates: { canonical: "/dpa" },
        })
      : {},
  component: () => <>{Route.useLoaderData()}</>,
});
